import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { getFastlyImage } from "../../../utils/helpers/get-image-from-path";

const CdpOverviewRevamp = ({content, config}) => {
    const {overview } = content || {};
    const {features = []} = overview || {};
    return (
        <div styleName={"styles.overviewWrapper"}>
            {features.map((item, index) =>
                (<div key={index} className="media" styleName={"styles.mediaWrapper"}>
                    <img src={getFastlyImage(config, item.image)} />
                    <div className="media-body">
                        <p styleName={"styles.heading"}>{item.title}</p>
                        <p styleName={"styles.subHeading"}>{item.subTitle}</p>
                    </div>
                </div>)
            )}
        </div>
    );
};

CdpOverviewRevamp.propTypes = {
    content: PropTypes.object,

    config: PropTypes.object,
    featureRef: PropTypes.func,
    handleFeatureModal: PropTypes.func,
    isFetchingFromCarCard: PropTypes.bool
};

export default CdpOverviewRevamp;
